module.exports = __webpack_public_path__ + "static/img/huaiLun.45d1977.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LunBo/huaiLun.jpg
// module id = TfPz
// module chunks = 0